/**
 * aircraft — part of the German catalogue (the reference language).
 * Merged in `i18n/de.ts`; every key here must exist in `i18n/en/aircraft.ts`.
 */

export const aircraft = {
  'ac.title': 'Meine Flugzeuge',
  'ac.lead':
    'Ein Profil beschreibt genau dieses Flugzeug. Eine Vorlage liefert nur Startwerte für das Muster. Was aus POH oder Wägebericht stammt, haken Sie ab – nur das gilt als bestätigt.',
  'ac.mine': 'Flugzeuge',
  'ac.add': 'Flugzeug hinzufügen',
  'ac.empty': 'Noch kein Flugzeug angelegt.',
  'ac.nonumbers': 'noch keine Werte hinterlegt',
  'ac.edit': 'Bearbeiten',
  'ac.delete': 'Löschen',
  'ac.confirm.delete': '„{reg}“ löschen? Pläne behalten ihre Werte, werden aber nicht mehr versorgt.',
  'ac.cancel': 'Abbrechen',
  'ac.save': 'Speichern',
  'ac.busy': 'speichert …',

  'ac.step1.title': 'Muster wählen',
  'ac.step1.hint': 'Die Vorlage füllt das Formular vor. Jeder Wert bleibt änderbar.',
  'ac.search.label': 'Muster suchen',
  'ac.search.ph': 'C172, Piper, DA40 …',
  'ac.search.none': 'Kein Muster gefunden — „ohne Vorlage“ anlegen.',
  'ac.nopreset': 'ohne Vorlage',

  'ac.step2.title': 'Flugzeug anlegen',
  'ac.step2.edit': 'Flugzeug bearbeiten',
  'ac.sec.id': 'Flugzeug',
  'ac.reg': 'Kennzeichen',
  'ac.reg.hint': 'Wird in Großbuchstaben gespeichert.',
  'ac.reg.ph': 'D-EAZA',
  'ac.icao': 'Muster (ICAO)',
  'ac.type_label': 'Muster (Klartext)',

  'ac.sec.cruise': 'Reiseflug',
  'ac.sec.cruise.code': 'TAS · Verbrauch',
  'ac.sec.cruise.hint': 'Diese beiden Werte füllen TAS je Abschnitt sowie Reise-, Reserve- und Vorratskraftstoff.',
  'ac.sec.climb': 'Steigflug',
  'ac.sec.fuel': 'Kraftstoff',
  'ac.sec.fuel.hint': 'Mengen dieses Flugzeugs — Tankausbau und Betriebshandbuch, nicht der Katalog.',
  'ac.sec.mass': 'Masse & Schwerpunkt',
  'ac.sec.mass.hint':
    'Leermasse und Leermoment stehen im Wägebericht dieses Flugzeugs. Die Vorlage nennt nur eine typische Größenordnung.',
  'ac.sec.other': 'Sonstiges',

  'ac.f.tas': 'TAS',
  'ac.f.lph': 'Verbrauch',
  'ac.f.power': 'Leistung',
  'ac.f.alt': 'Höhe',
  'ac.f.climb_fpm': 'Steigrate',
  'ac.f.climb_lph': 'Verbrauch im Steigflug',
  'ac.f.usable': 'Ausfliegbarer Kraftstoff',
  'ac.f.unusable': 'Nicht ausfliegbarer Kraftstoff',
  'ac.f.unusable.hint': 'Wird als Masse gerechnet: Liter × 0,72 kg/l (Avgas).',
  'ac.f.taxi': 'Anlassen und Rollen',
  'ac.f.reserve': 'Reserve',
  'ac.f.reserve.hint': 'Vorgabe 45 min. Die Mindestreserve hängt von der Betriebsart ab (NCO.OP.125) — bitte prüfen.',
  'ac.f.empty_kg': 'Leermasse',
  'ac.f.empty_mom': 'Leermoment',
  'ac.f.empty_arm': 'Leerhebelarm',
  'ac.f.mtow': 'Höchstzulässige Startmasse',
  'ac.f.unit_mass': 'Einheit Masse',
  'ac.f.unit_moment': 'Einheit Moment',
  'ac.f.seats': 'Sitze',
  'ac.f.notes': 'Notizen',
  'ac.f.source': 'Vorlage nach {note}',

  'ac.cruisetable': 'Reiseleistungen der Vorlage',
  'ac.cruisetable.hint':
    'Aus der Vorlage übernommen. Die Zeile mit der höchsten Leistung liefert TAS und Verbrauch oben, falls diese leer bleiben.',
  'ac.cruisetable.drop': 'Tabelle verwerfen',

  'ac.confirm.field': 'aus POH/Wägebericht bestätigt',
  'ac.badge.confirmed': 'bestätigt',
  'ac.badge.preset': 'Vorlage (Schätzung)',
  'ac.badge.preset.short': 'Vorlage',
  'ac.badge.unconfirmed': 'nicht bestätigt',

  'ac.meta.tas': 'TAS {v} kt',
  'ac.meta.lph': '{v} l/h',
  'ac.meta.usable': '{v} l ausfliegbar',
  'ac.meta.mtow': 'MTOM {v} kg',
  'ac.meta.seats': '{v} Sitze',

  'ac.err.reg': 'Kennzeichen fehlt oder ist zu lang (3–12 Zeichen).',
  'ac.err.numbers': 'Mindestens ein Feld ist keine gültige Zahl oder liegt außerhalb des zulässigen Bereichs.',
  'ac.err.mass': 'Die Leermasse ist größer als die höchstzulässige Startmasse.',
  'ac.field.derived': 'aus dem Flugzeugprofil {reg}',
  'ac.field.derived.est': 'aus dem Flugzeugprofil {reg} – Wert der Vorlage, nicht bestätigt',
} as const;
